module.exports = __webpack_public_path__ + "img/inline-spacing.e057e5eb.svg";